<div class="container-fluid">

  <router-outlet>

  </router-outlet>

</div>
